module.exports = __webpack_public_path__ + "static/media/(H)_MG_5716_-_Cia_Termal_Beachewear_-_Moda_Feminina.676c1828.jpg";